module.exports = __webpack_public_path__ + "static/img/67a32ea9e2924087ce29588e4886d6c7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Arrow.png
// module id = gcc/
// module chunks = 1